import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { commonSearch } from '@/api/common/search';

export default {
  name: 'DemandSelector',

  componentName: 'DemandSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      options: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        filterable: true,
        placeholder: '请输入需求名称或需求ID',
        remote: true,
        'popper-class': 'm-custom-select s-sm',
        options: this.options
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  methods: {
    handleRemote: function handleRemote(query) {
      var _this = this;

      if (!query) return;
      this.loading = true;
      var params = this.config.params ? this.config.params.params : {};
      var postData = _Object$assign({}, params, {
        type: 'demand',
        keyword: query
      });
      commonSearch(postData).then(function (res) {
        _this.options = (_.get(res, 'data.data.list') || []).map(function (item) {
          return {
            label: item.title,
            value: item.id
          };
        });
        _this.loading = false;
      }).catch(function () {
        _this.options = [];
        _this.loading = false;
      });
    },
    setOptions: function setOptions(options) {
      this.options = options;
    }
  }
};